import type { StatsSnapshot } from './gameplay-snapshot';
import { useCurrencyStore } from '../store/zustand/useCurrencyStore';
import { multiplyAll } from '@game-libs/exc-libs/src/helpers/array.helpers';
import { unitStats as stats } from './index';
import { CONFIG } from '../config';

export const updateThiefStats = (state: StatsSnapshot) => {
  const upgrades = state.upgrades.thief;
  const thief = state.generators.thief;

  const baseDamage = upgrades.sharpDagger.multiplier;
  const damagePerTick = baseDamage * thief.owned;

  const baseGold = thief.baseGeneration;
  const currency = useCurrencyStore.getState();
  const inspirationMultiplier = currency.inspiration.remainingActive > 0 ? currency.inspiration.multiplier : 1;

  const goldMultiplier = multiplyAll([
    upgrades.pickpocket?.multiplier || 1,
    upgrades.midasTouch?.multiplier || 1,
    inspirationMultiplier,
  ]);

  const goldGeneration = thief.owned * baseGold * goldMultiplier + damagePerTick * CONFIG.game.goldPerDamage;

  stats.thief = {
    mainIndividualGenerationStat: baseGold * goldMultiplier + baseDamage * CONFIG.game.goldPerDamage,
    damagePerTick,
    goldGeneration,
  };
};
